import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { Modal } from 'antd';
import { APITypes, PlyrProps, usePlyr } from 'plyr-react';
import 'plyr-react/plyr.css';
import { forwardRef, useEffect, useState } from 'react';

const Player = forwardRef<APITypes, PlyrProps>((props, ref) => {
  const { source, options = null } = props;
  const { show, remove } = useModal();
  const [signal, setSignal] = useState(false);
  const [isModalShow, setIsModalShow] = useState(true);
  const raptorRef = usePlyr(ref, {
    source,
    options,
  });
  useEffect(() => {
    setIsModalShow(!signal);
  }, [signal]);
  return (
    <Modal
      width={1100}
      styles={{
        content: {
          padding: '0px',
        },
      }}
      closeIcon={false}
      centered
      destroyOnClose
      footer={<></>}
      open={isModalShow}
      onOk={() => {
        setSignal(true);
        show();
      }}
      onCancel={() => {
        setSignal(false);
        remove();
      }}
    >
      <video ref={raptorRef} className="plyr-react plyr" />
    </Modal>
  );
});

const WrappedPlayer = () => {
  return (
    <Player
      source={{
        title: 'IDP文档审阅',
        sources: [
          {
            src: 'https://cdn-static-resources.ai-indeed.com/supertext/videos/szzn_idp_intro.mp4',
          },
        ],
        type: 'video',
      }}
      options={{
        tooltips: {
          controls: false,
        },
        invertTime: false,
        controls: [
          'play-large',
          'play',
          'progress',
          'current-time',
          'mute',
          'volume',
          'captions',
          'fullscreen',
        ],
        autoplay: true,
        disableContextMenu: true,
        settings: [],
        storage: {
          enabled: false,
        },
        keyboard: {
          focused: true,
          global: true,
        },
      }}
    />
  );
};

export const VideoPlayer = NiceModal.create(() => (
  <WrappedPlayer></WrappedPlayer>
));
